import { render, staticRenderFns } from "./presaleUpgradeList.vue?vue&type=template&id=9ae1ea20&scoped=true&"
import script from "./presaleUpgradeList.vue?vue&type=script&lang=js&"
export * from "./presaleUpgradeList.vue?vue&type=script&lang=js&"
import style0 from "./presaleUpgradeList.vue?vue&type=style&index=0&id=9ae1ea20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae1ea20",
  null
  
)

export default component.exports